import {
    SreHashingFailure,
    SreProgressStage,
} from '../../../../../AGSS/models/SreHealth';

const HASH_ENTRY = /(^|\/)[0-9a-f]{64}$/i;
export const isHashEntry = (value: string): boolean =>
    HASH_ENTRY.test(value.trim());
export const bareHash = (value: string): string => {
    const trimmed = value.trim();
    return isHashEntry(trimmed)
        ? trimmed.slice(trimmed.lastIndexOf('/') + 1)
        : trimmed;
};

export const formatFindingEntry = (value: string): string =>
    isHashEntry(value) ? `Build/${bareHash(value).toLowerCase()}` : value;

export const uniqueFindingEntries = (values: readonly string[]): string[] =>
    Array.from(new Set(values.map(formatFindingEntry)));

export const findingEntries = (
    findings: ReadonlyArray<{ entry: string }>
): string[] => uniqueFindingEntries(findings.map((finding) => finding.entry));

export const uniqueHashingFailures = (
    failures: readonly SreHashingFailure[]
): SreHashingFailure[] => {
    const reasonsByEntry = new Map<string, Set<string>>();
    for (const failure of failures) {
        const file = formatFindingEntry(failure.file);
        let reasons = reasonsByEntry.get(file);
        if (!reasons) {
            reasons = new Set<string>();
            reasonsByEntry.set(file, reasons);
        }
        if (failure.reason) reasons.add(failure.reason);
    }
    return Array.from(reasonsByEntry, ([file, reasons]) => ({
        file,
        reason: Array.from(reasons).join('\n'),
    }));
};

export const findingsText = (
    identifier: string,
    stages: SreProgressStage[]
): string =>
    stages
        .filter((stage) => stage.validationDetail)
        .map((stage) => {
            const detail = stage.validationDetail!;
            return [
                `${identifier} - ${stage.stage}`,
                ...detail.groups.map((group) => {
                    const files = uniqueFindingEntries(group.files);
                    return `${group.name} (${files.length}${
                        group.truncated ? '+' : ''
                    }):\n${files.join('\n')}`;
                }),
                ...uniqueHashingFailures(detail.hashingFailures).map(
                    (failure) =>
                        `${failure.file}${
                            failure.reason ? ` - ${failure.reason}` : ''
                        }`
                ),
                ...(detail.truncated
                    ? [
                          'Partial preview. Use findings export for the full report.',
                      ]
                    : []),
            ].join('\n\n');
        })
        .join('\n\n----------\n\n');
